export default {
  DEFAULT_ERROR: 'Something went wrong. Please try again.',
  FAILED_ON_FETCH_DATA: 'Failed to fetch data. Please try again.',
  FAILED_ON_LOAD_DATA: (entity = 'data') => `Failed to fetch ${entity}. Please try again.`,
  FAILED_ON_CREATE_DATA: entity => `Failed to create ${entity}. Please, try later.`,
  FAILED_ON_DELETE_DATA: 'Failed to delete data. Please, try later.',
  FAILED_ON_UPDATE_DATA: 'Failed to update data. Please, try later.',
  FAILED_ON_DOWNLOAD_CSV: 'Failed to download CSV file. Please, try later.',
  FILL_REQUIRED_FIELDS: 'Please fill the required fields!',
  FILL_MANDATORY_FIELDS: 'Please fill all mandatory fields!',
  FIELD_REQUIRED: (name = 'Field') => `${name} is required`,
  FIELD_INVALID: (name = 'Field') => `${name} is invalid`,
  NEW_LIVESTOCK_FOR_CALF_RECORD: 'New Livestock Record for calf created',
  NEW_BREEDING_EVENT_BIRTH_FOR_CALF: 'New Breeding event - Birth for calf created',
  NEW_MEASUREMENT_EVENT_CALVING_WEIGHT_FOR_CALF: 'New Measurement event - Calving weight for calf created',
  NEW_MEASUREMENT_EVENT_POST_CALVING_WEIGHT_FOR_CALF: 'New Measurement event - Post calving weight for calf created',
  NEW_MEASUREMENT_EVENT_CALVING_EASE_FOR_COW: 'New Measurement event - Calving Ease for cow created',
  NEW_TREATMENT_FOR_COW: 'New Treatment event for cow created',
  NEW_TREATMENT_FOR_CALF: 'New Treatment event for calf created',

  SELECTED_ITEM_REQUIRED: 'Please select at least one record.',

  EVENT_TITLE_REQUIRED: 'Title is required',
  EVENT_START_DATE_REQUIRE: 'Start date is required',
  EVENT_END_DATE_REQUIRED: 'End date is required',
  EVENT_PROVIDE_RELATION: 'Please select a related record',
  EVENT_PROVIDE_RECURRING_DATE: 'Provide please recurring date',
  EVENT_START_DATE_AFTER_END_DATE: "Start date can't be after end date",
  EVENT_REMIND_DATE_IN_PAST: "Remind date can't be in the past",
  EVENT_REMIND_DATE_AFTER_START_DATE: "Remind date can't be after start date",

  TASK_PROVIDE_RELATION: 'Please select a related record',
  TASK_PROVIDE_RECURRING_DATE: 'Provide please recurring date',
  TASK_REMIND_DATE_IN_PAST: "Remind date can't be in the past",
  TASK_REMIND_DATE_AFTER_DUE_DATE: "Remind date can't be after due date",

  ACCEPT_TERMS_AND_CONDITIONS: 'You can only proceed if you accept the terms and conditions. Your account is archived.',
  ADD_USER_EMAIL_REQUIRED: 'Email is required',
  ADD_USER_ROLE_REQUIRED: 'Role is required',

  ANIMAL_UNLINK_TAG_REQUIRED: 'Please unlink the Kraal Tag before making this change',
  ANIMAL_FARM_REQUIRED: 'No Farm exists. Please create at least one Farm to add Livestock.',
  MASTER_GEOFENCE_REQUIRED: 'To save a farm record, you must create a geofence on the map for the farm.',

  LOSS_REASON_REQUIRED: 'Loss reason is required when a loss date is entered.',
  LOSS_DATE_REQUIRED: 'Loss date is required when a loss reason is entered.',
  DATE_SOLD_REQUIRED: 'Date sold is required when a sold to is entered.',
  SOLD_TO_REQUIRED: 'Sold to is required when a date sold is entered.',
  PURCHASED_FROM_REQUIRED: 'Purchased from is required when a purchase date is entered.',
  PURCHASE_DATE_REQUIRED: 'Purchase date is required when a purchased from is entered.',
  LOSS_OR_SOLD_DATE_REQUIRED_BEFORE_DELETE:
    'Please set either the loss date or the sold date before making this change.',

  MEASUREMENT_NOT_FOUND: 'No existing measurement record was found to edit. Please add a new measurement record.',

  NOTIFICATIONS_LIMIT: 'Only the most recent 100 records will be listed',
  NO_LOCATION_DATA_AVAILABLE_FOR_TIME_FRAME: 'No location data is available for the selected time frame',
  PARTIAL_LOCATION_DATA_AVAILABLE_FOR_PART_TIME: 'Only partial location data is available for the selected time frame',

  ARCHIVED: 'Archived successfully!',
  CREATED: 'Created successfully!',
  UPDATED: 'Updated successfully!',
  DELETED: 'Deleted successfully!',

  SET_PASSWORD_EMAIL_SENT: 'Set password email sent',
  SET_PASSWORD_EMAIL_FAILED: (failedEmails = []) => `Set password email was not sent for ${failedEmails.join(', ')}.`,

  DATA_REQUIRED: 'Please fill in the required details before saving.',
  SHAPE_OUTSIDE_BOUNDARIES: entity => `You have placed the ${entity} outside the farm.`,
  GEOFENCE_OUTSIDE_MASTER:
    'This update will cause one or more pastures to fall outside of the farm.  Please correct the pasture(s) before updating the farm.',
  FILE_TOO_LARGE: sizeWithUnit => `File is too big. It must be smaller than ${sizeWithUnit}!`,
  FILE_TYPE_NOT_ALLOWED: 'You can only upload JPG/PNG file!',
  ARCHIVE_CONFIRMATION: entity => `Are you sure you want to archive selected ${entity}? This action cannot be undone.`,

  CANT_MOVE_AN_EVENT_INTO_THE_PAST: "You can't move an event into the past.",
  CANT_MOVE_AN_TASK_INTO_THE_PAST: "You can't move an task into the past.",

  CREATE_EVENT: entity => `First, create a ${entity} for the animal through the ‘Actions’ menu.`,
  CREATE_ROTATION: 'First, create a grazing for the pasture through the ‘Actions’ menu.',
  NO_GRAZING: "Selected pastures don't have any grazing yet.",
  PASSWORDS_MISMATCH: 'Please make sure both password fields are the same.',
  PASSWORD_INVALID:
    'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.',
  AGREED_REQUIRED: 'You must agree to continue.',

  LIVESTOCKS_TO_PHYS_GROUP_ASSIGNMENT:
    'One or more livestocks are already assigned to group with type "physical". Do you want to remove selected livestock(s) and assign it to this group?',
  LIVESTOCK_TO_PHYS_GROUP_ASSIGNMENT: groupName =>
    `This livestock is already assigned to ${groupName}. Do you want to remove this livestock from ${groupName} and assign it to this group?`,
  RATE_LIMIT_REACHED: 'Rate limit reached. Please slow down.'
};
